module.exports = __webpack_public_path__ + "static/media/1f60a.9ac49133.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f60a.svg
// module id = 616
// module chunks = 1